import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '../contexts/AuthProvider';
import { getCookie } from '../helpers/session';

/**
 * HOC for Auth page
 */
const withPublic = PageComponent => {
  return props => {
    const router = useRouter();
    const { isLoggedIn } = useAuth();
    useEffect(() => {
      if (navigator.cookieEnabled) {
        if (getCookie('id_token')) {
          router.replace('/');
          return null;
        }
      } else {
        if (isLoggedIn) {
          router.replace('/');
          return null;
        }
      }
    }, []);
    return <PageComponent {...props} isLoggedin={false} />;
  };
};

export default withPublic;
